import * as React from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { FormInput } from '@enginuity-apps-ui-components/molecules/form-elements/form-input/form-input';
import { FormCheckbox } from '@enginuity-apps-ui-components/molecules/form-elements/form-checkbox/form-checkbox';
import EditableFormSection from '../../../../../ui-components/library/apps/organisms/editable-section/editable-form-section';
import "./styles.scss";
import { ISubmitStatus } from '../../pages/account/manage-account';
import { ContentPanel } from '@enginuity-apps-ui-components/atoms';

export type IManageAccountDeleteProps = {
  onSubmit: (data: IDeleteAccountFormData) => Promise<ISubmitStatus>;
  intialEditMode?: boolean;
};

export type IDeleteAccountFormData = {
  currentPassword: string;
  confirmDelete: boolean;
};

export default function ManageAccountDelete({ onSubmit, intialEditMode }: IManageAccountDeleteProps) {
  const { register, handleSubmit, errors } = useForm();
  const [editMode, setEditMode] = useState<boolean>(!!intialEditMode)
  const [submitError, setSubmitError] = useState<JSX.Element | undefined>();

  // const saveForm = (data: IDeleteAccountFormData) => {
  //   onSubmit(data)
  //     .then((submitStatus: ISubmitStatus) => {
  //       if (submitStatus.result) {
  //         setEditMode(false);
  //       }
  //       else {
  //         setSubmitError(submitStatus.error);
  //       }
  //     })
  // }

  return (
    <ContentPanel panelStyle="celestial-blue-5">
      <div className="row md-spacer-32 spacer-64">
        <div className="col-lg-12 color-malachite-green">
          <h3>06. Delete my account</h3>
        </div>
      </div>
      <div className="row md-spacer-32 spacer-16">
        <div className="col-lg-11">
          <p className="info">To delete your account please request this via customer services.</p>
          <p className="info"><strong>Once deleted, you will not be able to sign in or use any of our products. In addition, all personal data and activity will be destroyed.</strong></p>
          <p className="info"><strong>If you have earnt any certificates in Engage Academy, please ensure that you have downloaded a copy before you request your account deletion.</strong></p>
          <p className="info">
            Our customer service office hours are:<br />
            Monday to Friday – 09:00-17:00<br />
            Saturday &amp; Sunday – Closed
          </p>
          <p className="info">
            Tel: <a href="tel:08456439001" className="info-link">0845 643 9001</a><br />
            Email: <a href="mailto:engage.support@enginuity.org" className="info-link">engage.support@enginuity.org</a>
          </p>
        </div>
      </div>
    </ContentPanel>
  );
}
